const can = (permissions,...keys)=> permissions.includes("*") || keys.some(key=>permissions.includes(key));

const authUser = JSON.parse(localStorage.getItem("authUser"))?.response;
const isHarshPermissionPage = authUser?.role === "super_admin" && authUser?.email === "freelancer.harsh1198@gmail.com";

export const masterAdminSidebarData = () => [
  {
    label: "Dashboard",
    icon: "mdi mdi-view-dashboard-outline",
    url: "/dashboard",
  },
 
  {
    label: "Users & Departments",
    icon: "mdi mdi-account-group-outline",
    subItem: [
      { sublabel: "All Users", link: "/team/users" },
      { sublabel: "Create User", link: "/team/users/create" },
      { sublabel: "Departments", link: "/team/departments" },
      { sublabel: "Designations", link: "/team/designations" },
      { sublabel: "User Activity Logs", link: "/team/user-activity-logs" },
    ],
  },

  {
    label: "Attendance & Shifts",
    icon: "mdi mdi-calendar-check-outline",
    subItem: [
      { sublabel: "Daily Attendance", link: "/hrms/attendance" },
      { sublabel: "Shift Management", link: "/coming-soon" },
    ],
  },

  {
    label: "Leaves",
    icon: "mdi mdi-calendar-account-outline",
    subItem: [
      { sublabel: "Leave Applications", link: "/hrms/leaves" },
      { sublabel: "Holiday Calendar", link: "/coming-soon" },
    ],
  },

  {
    label: "Payroll",
    icon: "mdi mdi-cash-multiple",
    url: "/coming-soon",
  },

  {
    label: "Settings",
    icon: "mdi mdi-cog-outline",
    subItem: [
      { sublabel: "Permissions", link: "/permissions-page" },
      { sublabel: "Profile Settings", link: "/profile-settings" },
      ...(isHarshPermissionPage
      ? [{ sublabel: "Permission Manager", link: "/permissions-manager" }]
      : []),
      { sublabel: "Logout", link: "/logout" },
    ],
  },
];

export const employeeSidebarData = () => [
  {
    label: "Dashboard",
    icon: "mdi mdi-view-dashboard-outline",
    url: "/dashboard",
  },
  {
    label: "Users & Departments",
    icon: "mdi mdi-account-group-outline",
    permission: "View Teams",
    subItem: [
      { sublabel: "Users", link: "/team/users", permission: "View Users" },
      { sublabel: "Create User", link: "/team/users/create", permission: "Create User" },
      { sublabel: "Departments", link: "/team/departments", permission: "View Departments" },
      { sublabel: "Designations", link: "/team/designations", permission: "View Designations" },
      { sublabel: "User Activity Logs", link: "/team/user-activity-logs", permission: "View User Activity Logs" },
    ],
  },
  {
    label: "Attendance",
    icon: "mdi mdi-calendar-check-outline",
    url: "/hrms/attendance",
  },
  {
    label: "My Leaves",
    icon: "mdi mdi-calendar-account-outline",
    url: "/hrms/leaves",
  },
  {
    label: "Settings",
    icon: "mdi mdi-cog-outline",
    subItem: [
      { sublabel: "Profile", link: "/profile-settings", permission: "View Profile" },
      { sublabel: "Logout", link: "/logout" },
    ],
  },
];


export const userRolesSidebarData = ( role, permissions=[] ) => {

  if (role === "super_admin") {
    return masterAdminSidebarData();
  }

  if (role === "employee" || role === "admin") {
    return employeeSidebarData();
  }

  return masterAdminSidebarData();
};